<template>
  <el-table
    :data="profiles"
    stripe
    size="mini"
  >
    <el-table-column
      label="Name"
      :formatter="row => $_.get(row, 'name_full', '-')"
    />
    <el-table-column
      label="Email"
      :formatter="row => $_.get(row, 'email', '-')"
    />
  </el-table>
</template>

<script>
export default {
  props: {
    profiles: {
      type: Array,
      required: true
    }
  }
}
</script>

<style>

</style>
